import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import withTrip from '../withTrip';
import TripQuantitySelector from './TripQuantitySelector';
import CarRentalQuantitySelector from './CarRentalQuantitySelector';
import SouvenirQuantitySelector from './SouvenirQuantitySelector';
import TicketQuantitySelector from './TicketQuantitySelector';

const QuantitySelector = (props) => {
  const { trip, onChangeCustomize } = props;
  const productType = trip.product_type;
  const fixedQuantity = trip.fixed_quantity;
  return (
    <Fragment>
      {productType === 'trip' && <TripQuantitySelector onChangeCustomize={onChangeCustomize} />}
      {productType === 'car_rental' && fixedQuantity === 1 && <CarRentalQuantitySelector />}
      {productType === 'souvenir' && <SouvenirQuantitySelector />}
      {productType === 'ticket' && <TicketQuantitySelector />}
    </Fragment>
  );
};

QuantitySelector.propTypes = {
  trip: PropTypes.object,
  onChangeCustomize: PropTypes.func,
};

export default withTrip(QuantitySelector);
